import React, { useEffect, useState, forwardRef, useRef } from 'react';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { useAppDispatch, RootState } from '@/store';
import { getCalendar } from '@/store/calendar/action';
import { getUserVenues } from '@/store/user-info/action';
import { getCustomerList, createCustomer } from '@/store/customer/action';
import { getVenueDetail } from '@/store/venue-detail/action';
import { createBooking } from '@/store/bookings/action';
import HeaderLayout from "@/components/common/CustomLayout/HeaderLayout";
import { ReactComponent as RiArrowLeft } from '@/assets/icons/arrow-left.svg'
import { ReactComponent as RiArrowRight } from '@/assets/icons/arrow-right.svg'
import { ReactComponent as InformationIcon } from '@/assets/icons/ri-information-line-2.svg';
import Input from '@/components/common/Input';
import Calendar from '@/components/common/Calendar';
import Summary from '@/pages/Bookings/Form/Summary';
import Button from "@/components/common/Button";
import Modal from '@/components/common/Modal';
import ConfirmationModal from '@/pages/Bookings/Form/ConfirmationModal';
import { renderCustomerFormHeader, renderCustomerFormBody, renderCustomerFormFooter } from '@/pages/Customers/Modal';
import 'react-datepicker/dist/react-datepicker.css'
import UserVenueSelect from "@/components/common/UserVenueSelect";
import { openingHours } from '@/utils/validation';
import { statusOptions } from '../constant';
import { CircularLoading } from '@/components/common/CircularLoading';


const OPENING_HOURS = openingHours;

const dateUpdate = (operator: string, startDate: number) => {
  let newStart = startDate
  if (operator === 'prev') {
    newStart += -7 * 24 * 60 * 60 * 1000
  } else if (operator === 'next') {
    newStart += 7 * 24 * 60 * 60 * 1000
  }
  return {
    newStart: new Date(newStart).getTime(),
    newEnd: new Date(newStart + 6 * 24 * 60 * 60 * 1000).getTime()
  }
}
const handleSubmit = (
  selectedSchedules: ScheduleList,
  { bookingMethods }: any,
  { summaryMethods }: any,
  selectedBookingType,
  selectedVenue,
  dispatch: Function,
  navigate: Function,
  setIsSubmitLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setShow?: Function) => {

  const details = Object.entries(selectedSchedules).map((schedule: {}) => schedule[1].map(bookingDetail => {
      const { court, hour, selectedDate, price } = bookingDetail
      return {
        venue_court_id: court.id,
        start_time: hour,
        end_time: hour+1,
        date: selectedDate,
        price
      }
    })
  )
  const payload : BookingPayload = {
    label: bookingMethods.getValues('bookingLabel'),
    customer_id: bookingMethods.getValues('customerName')?.value,
    type: selectedBookingType,
    venue_id: selectedVenue.id,
    status: statusOptions[0],
    coupon_code: summaryMethods.getValues('coupon'),
    booking_method_id: summaryMethods.getValues('bookingMethod')?.value,
    total_price: details?.flat()?.map(detail => detail.price)?.reduce((num, total = 0) => total + num),
    final_price: summaryMethods.getValues('manualPrice') !== "" ? Number(summaryMethods.getValues('manualPrice')) : details?.flat()?.map(detail => detail.price)?.reduce((num, total = 0) => total + num),
    details: details.flat()
  }
  setIsSubmitLoading(true)
  dispatch(createBooking(payload)).then((res: {[key: string]: any}) => {
    setIsSubmitLoading(false)
    if (!res.error) {
      if (setShow) {
        setShow(true)
        return
      }
      toast.success('Successfully created a booking data')
      navigate('/dashboard/booking')
    }
  })
}

const ShowCalendar = forwardRef<any>((
  { value, onClick }: { value: string, onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void },
  ref) => (
  <Button variant="basic"
          type="button"
          className="border border-grey-line-subtle"
          onClick={onClick} ref={ref}>
    {value}
  </Button>))

const renderConfirmationFormBody = (
  customer,
  submitModal,
  selectedSchedules: ScheduleList,
  { bookingMethods }: any,
  { summaryMethods }: any,
  selectedBookingType,
  selectedVenue,
  dispatch: Function,
  navigate: Function,
  setIsSubmitLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setShow?: Function,) => ({
    children: (
      <>
        {(customer !== undefined && (!!customer.is_blocked || !!customer.is_invoice_overdue)) && <div className='flex flex-col justify-around h-full pb-4'>
					<div className='h-24 w-full flex justify-center text-red-primary'>
						<InformationIcon />
					</div>
					<div className='flex flex-col gap-2 justify-center items-center'>
						<div className='flex flex-col gap-1 px-6'>
							<p className='font-medium text-lg text-center mb-2'>Are you sure to create a new booking?</p>
              <ul className="list-disc pl-8 pr-4">
                { customer.is_invoice_overdue && 
                  <li>
                    <p className='text-sm text-grey-dark'>This Customer has overdue invoices!</p>
                  </li>
                }
                { customer.is_blocked && 
                  <li>
                    <p className='text-sm text-grey-dark'>This Customer got blocked due: <b>{customer.blocked_note}</b></p>
                  </li>
                }
              </ul>
						</div>
						<div className='flex gap-4 pt-4'>
							<Button type='submit' variant='primary'
											onClick={
                        bookingMethods.handleSubmit(() => {
                          handleSubmit(selectedSchedules, { bookingMethods }, { summaryMethods }, selectedBookingType, selectedVenue, dispatch, navigate, setIsSubmitLoading)
                          setShow(false)
                        }) 
                      }>
                        Yes, Im sure
              </Button>
							<Button type='button' variant='basic' className='border-grey-line-subtle border' onClick={() => setShow(false)}>No, cancel</Button>
						</div>
					</div>
        </div>}
        {(customer !== undefined && (!customer.is_blocked && !customer.is_invoice_overdue)) &&
					<div className='flex flex-col gap-2 justify-center items-center h-full pb-4'>
						<div className='flex flex-col items-center gap-1'>
							<p className='font-medium text-lg'>Success</p>
							<p className='text-sm text-grey-dark'>New booking created successfully</p>
						</div>
						<div className='flex gap-4'>
							<Button type='submit' variant='primary'
											onClick={bookingMethods.handleSubmit(() => navigate('/dashboard/booking'))}>OK</Button>
						</div>
					</div>}
      </>
    ),
    data: { value: { id: '' } },
  })

// const isInvoiceOverdue = (customers, selectedCustomer) => customers.find(customer => customer.id === selectedCustomer?.value && customer.is_invoice_overdue === true)
// const isCustomerBlocked = (customers, selectedCustomer) => customers.find(customer => customer.id === selectedCustomer?.value && customer.is_blocked === true)
const getCustomer = (customers, selectedCustomer) => customers.find(customer => customer.id === selectedCustomer?.value)

const BookingForm = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().setHours(0,0,0,0))
  const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7))
  const [endDate, setEndDate] = useState(new Date().setDate(new Date(startDate).getDate() + 6))
  const [selectedSchedules, setSelectedSchedules] = useState({})
  const [conflictingSchedules, setConflictingSchedules] = useState([])
  const [selectedVenue, setSelectedVenue] = useState(null)
  const [selectedBookingType, setSelectedBookingType] = useState<string>('REGULAR')
  const [holiday, setHoliday] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const { state: calendarItems } = useSelector((state: RootState) =>  state.calendar)
  const venueState = useSelector((state: RootState) => state.userInfo.state.venues)
  const venueDetailState = useSelector((state: RootState) => state.venueDetail.venue)
  const customerState = useSelector((state: RootState) => state.customer.state.items)
  const [bookingByCourt, setBookingByCourt] = useState([])
  const bookingMethods = useForm()
  const summaryMethods = useForm()
  const customerMethods = useForm()
  const inputRef = useRef(null)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const showCustomerModal = () => {
    setShowModal(true)
  }
  const closeCustomerModal = () => {
    setShowModal(false)
  }
  const showConfirmationModal = () => {
    setConfirmationModal(true)
  }
  const closeConfirmationModal = () => {
    setConfirmationModal(false)
  }

  const submitModal = async () => {
    const customerData = customerMethods.getValues()
    const data = {
      "name": customerData.name,
      "phone_number": customerData.phoneNumber,
      "email": customerData.email,
      "club_name": customerData.clubName,
      "status": customerData.status
    }
    await dispatch(createCustomer(data)).then(async (res: {[key: string]: any}) => {
      if (!res.error) {
        await dispatch(getCustomerList({isAll: 'true'}))
      }
    })
    setShowModal(false)
  }

  useEffect(() => {
    (() => {
      dispatch(getUserVenues({}))
      dispatch(getCustomerList({isAll: 'true'}))
    })()
  }, [])
  useEffect(() => {
    (async () => {
      await dispatch(getCalendar({
        dateMeta: selectedDate,
        venueMeta: selectedVenue?.val.value
      }))
    })()
  }, [selectedVenue, selectedDate])
  useEffect(() => {

  }, [selectedDate])
  useEffect(() => {
    setBookingByCourt([])
    const bookings = []
    calendarItems.forEach(calendarItem => {
      setHoliday(calendarItem.is_holiday)
      const schedules = calendarItem.items?.map(item => (
        {
          hour: item.start_time || 0,
          type: item.event_type || '',
          detail: item.description || ''
        }
      ))
      bookings.push({
        code: calendarItem.court_code,
        id: calendarItem.court_id,
        schedules
      })
    })
    setBookingByCourt(bookings)
  }, [calendarItems])

  const validateBookingSubmission = () => {
    const customer = getCustomer(customerState, bookingMethods.watch('customerName'))
    if (customer === undefined) return;
    if (!customer.is_invoice_overdue && !customer.is_blocked) {
      handleSubmit(selectedSchedules, { bookingMethods }, { summaryMethods }, selectedBookingType, venueDetailState, dispatch, navigate, setIsSubmitLoading, () => setConfirmationModal(true), );
    } else {
      setConfirmationModal(true)
    }
  }

  return (
    <div>
      <HeaderLayout
        title="Add Booking"
        rightComponent={
          <Button
            type="submit"
            variant="primary"
            className="whitespace-nowrap flex gap-2 px-12 py-2 justify-center items-center text-jsm font-medium"
            form="bookingForm"
            onClick={() => bookingMethods.handleSubmit(() => validateBookingSubmission())}
          >{ isSubmitLoading ? <CircularLoading/> : 'Add Schedule' }</Button>}
      >
        <div className="flex items-start gap-6">
          <div className="flex flex-col basis-9/12 items-start gap-6">
            <div className="flex items-start w-full bg-white p-0">
              <div className="flex flex-col items-start w-full bg-white p-0">
                <div className="flex flex-col p-0 w-full">
                  <p className="pt-7 pl-7 font-bold text-lg">Customer Information</p>
                </div>
                <form className="w-full" id="bookingForm" onSubmit={bookingMethods.handleSubmit(() => validateBookingSubmission())}>
                  <FormProvider {...bookingMethods}>
                    <div className="flex p-7 gap-7 justify-between w-full">
                      <div className="flex flex-col p-0 gap-2 w-full">
                        <p className="font-medium text-sm w-full">Customer Name</p>
                        <div className='flex w-full'>
                          <Controller
                            name="customerName"
                            render={({ field }) =>
                              <Select
                                className='w-full rounded-none'
                                options={
                                  customerState.map(customer => ({
                                    label: `${customer.name} (${customer.phone_number})`,
                                    value: customer.id
                                  }))
                                }
                                placeholder="Select customer"
                                {...bookingMethods.register('customerName')}
                                {...field}
                              />
                            }
                          />
                          <Button className='ml-2' type='submit' variant='primary' onClick={() => showCustomerModal()}>Add</Button>
                        </div>
                      </div>
                      <div className="flex flex-col p-0 gap-2 w-full">
                        <p className="font-medium text-sm">Booking Label</p>
                        <Input name="bookingLabel" type="text" placeholder="Suggestion Text" className="w-full" {...bookingMethods.register('bookingLabel')}/>
                      </div>
                    </div>
                  </FormProvider>
                </form>
              </div>
            </div>
            <div className="flex flex-col w-full bg-white">
              <div className="flex w-full px-6 py-8 gap-7 border-b border-grey-line-subtle">
                <p className="font-bold text-lg w-3/5">Choose Booking Type</p>
                <div
                  className="flex rounded border border-grey-line-subtle w-full">
                  <div className='flex w-full h-full items-center'>
                    <input type="radio" name="bookingType" id="regular" value='REGULAR' className="peer hidden" checked={selectedBookingType === 'REGULAR'} onChange={e => setSelectedBookingType(e.target.value)}/>
                    <>{ /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }</>
                    <label
                      htmlFor="regular"
                      className="flex items-center justify-center cursor-pointer select-none w-full h-full peer-checked:bg-blue-light peer-checked:text-white"
                    >Regular</label>
                  </div>
                  <div className="flex w-full h-full items-center">
                    <input type="radio" name="bookingType" id='event' value='EVENT' className="peer hidden" checked={selectedBookingType === 'EVENT'} onChange={e => setSelectedBookingType(e.target.value)}/>
                    <>{ /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }</>
                    <label
                      htmlFor="event"
                      className="flex items-center justify-center cursor-pointer select-none w-full h-full peer-checked:bg-blue-light peer-checked:text-white"
                    >Event</label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center w-full py-6 px-8 gap-12">
                <UserVenueSelect
                  options={
                    venueState.map(venue => ({
                      label: venue.name,
                      value: venue.id
                    }))
                  }
                  placeholder='Select venue'
                  onChange={(val: { label: string, value: string }) => {
                    setSelectedVenue({ val })
                    dispatch(getVenueDetail(val.value))
                    
                    summaryMethods.reset({
                      coupon: '',
                      bookingMethod: null,
                      manualPrice: ''
                    })
                    setSelectedSchedules({})
                    setConflictingSchedules([])
                  }}
                  isClearable
                />
                <div className="flex gap-2">
                  <Button variant="basic"
                          type="button"
                          className="border border-grey-line-subtle"
                          onClick={() => {
                            const newDates = dateUpdate('', new Date().getTime())
                            setStartDate(newDates.newStart)
                            setEndDate(newDates.newEnd)
                          }}>
                    Today
                  </Button>
                  <Button variant="basic"
                          type="button"
                          className="border border-grey-line-subtle"
                          onClick={() => {
                            const newDates = dateUpdate('prev', startDate)
                            setStartDate(newDates.newStart)
                            setEndDate(newDates.newEnd)
                          }}><RiArrowLeft/></Button>
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(date) => {
                      const { newStart, newEnd } = dateUpdate('', date[0].getTime())
                      setStartDate(newStart)
                      setEndDate(newEnd)
                    }}
                    customInput={<ShowCalendar ref={inputRef}/>}
                  />
                  <Button variant="basic"
                          type="button"
                          className="border border-grey-line-subtle"
                          onClick={() => {
                            const newDates = dateUpdate('next', startDate)
                            setStartDate(newDates.newStart)
                            setEndDate(newDates.newEnd)
                          }}><RiArrowRight/></Button>
                </div>
              </div>
              {selectedVenue && <Calendar startDate={startDate}
                         selectedDate={selectedDate}
                         setSelectedDate={setSelectedDate}
                         hours={OPENING_HOURS}
                         courts={venueDetailState?.courts || []}
                         bookingByCourt={bookingByCourt}
                         selectedSchedules={selectedSchedules}
                         setSelectedSchedules={setSelectedSchedules}
                         conflictingSchedules={conflictingSchedules}
                         setConflictingSchedules={setConflictingSchedules}
                         prices={venueDetailState?.prices}
                         bookingType={selectedBookingType}
                         holiday={holiday}
                         hideEmptyPrice
              />}
            </div>
          </div>
          <Summary summaryMethods={summaryMethods}
                   selectedSchedules={selectedSchedules}
                   conflictingSchedules={conflictingSchedules}
                   selectedVenue={venueDetailState}
                   selectedCustomer={bookingMethods.watch('customerName')}
                   customers={customerState}
                   dispatch={dispatch}
          />
        </div>
      </HeaderLayout>
      { showModal && <Modal show={showModal}
											 header={renderCustomerFormHeader}
											 body={renderCustomerFormBody({ customerMethods }, '', () => submitModal)}
											 footer={renderCustomerFormFooter(() => closeCustomerModal, () => submitModal)}
											 onClick={() => closeCustomerModal}
											 rootId="portal-customer-form"/> }
      { showConfirmationModal && <ConfirmationModal show={confirmationModal}
														body={
                              renderConfirmationFormBody(
                                getCustomer(customerState, bookingMethods.watch('customerName')), 
                                handleSubmit, selectedSchedules, { bookingMethods }, { summaryMethods }, selectedBookingType, venueDetailState, dispatch, navigate, setIsSubmitLoading, setConfirmationModal)}
														onClick={() => closeConfirmationModal}
														rootId="portal-customer-form"/> }
    </div>
  )
}

export default BookingForm
